import React            from 'react';
import { useState } from 'react';
import { B_ACTIONS } from '../bookingReducer';
import PersonSelect     from './PersonSelect';

/**
 * REACT component to allow the clinician to be changed when rescheduling 
 * a booking. Normally one would just allow the next avaialble clinician,
 * but for followups, the same clinician should be used.
 * @param {any} params containing:
 * clinician: Numeric PartID of the clinician chosen for this booking 
 * api: The API object, used to connect to IPRS API
 * selectedAppointmentTypeID: The app type ID for the booking.
 * newBooking: The booking object
 * bookingDispatch: The booking dispatch function used to dispatch events 
 * to the booking reducer. 
 */
const ReschedulePickTime = ({clinician, api, selectedAppointmentTypeID, 
    newBooking, bookingDispatch}) => {

    const [selectedUserID, setSelectedUserID]                   = useState(0);
    const [sameClinician, setSameClinician]                     = useState(false);

    const goAppTypeCalendar = e => {

        e.preventDefault();

        bookingDispatch(B_ACTIONS.PERSON, selectedUserID);
    }

    const switchSameClinician = e => {

        const val = e.target.checked;
        setSelectedUserID( val? clinician: 0 );
        setSameClinician(val);
    }

    const setIsVisual = val => {
        bookingDispatch(B_ACTIONS.VISUAL_CALL, val);
    }

    return <div>
       
        <p>Select an available time for this booking by going to the appointment type calendar</p>
        <button onClick={goAppTypeCalendar} >Go To Appointment Type Calendar</button>
        <p>Or go to one of the team calendars and select time in a person's individual calendar.</p>

        <PersonSelect clinician={selectedUserID} setSelectedUserID={setSelectedUserID} api={api} 
            selectedAppointmentTypeID={selectedAppointmentTypeID} 
            isVisual={newBooking.isVisual} disabled={sameClinician} setIsVisual={setIsVisual} >
            <>
                <label htmlFor='same-clinician'>Keep the same clinician</label>
                <input type='checkbox' name='same-clinician' id='same-clinician' checked={sameClinician} onChange={switchSameClinician} />
            </>
        </PersonSelect>
    </div>
}

export default ReschedulePickTime;
